/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Всплывающее окно рекомендации установки нового браузера
   */
  app.OldBrowserPopupView = app.View.extend({
    el: '.old-browser-popup',
    additionalOptions: ['versions', 'bowser', 'operaMiniOrMobileOptions', 'isPageSpeedTest'],
    events: {
      'click .js-old-browser-popup-close': 'close'
    },
    /**
     * @inheritDoc
     */
    run: function () {
      var isUnsupported = this.bowser.isUnsupportedBrowser(this.versions),
      isCookie = app.helpers.CookieHelper.getCookie('is_popup_old_browser_closed') === 1;
      if( this.operaMiniOrMobileOptions && this.operaMiniOrMobileOptions.name ) {
        this.bowser.name = this.operaMiniOrMobileOptions.name;
        isUnsupported = this.operaMiniOrMobileOptions.isUnsupported;
      }
      if (isUnsupported && !isCookie && !this.isPageSpeedTest) {
        switch (this.bowser.name) {
          case 'Chrome':
            this.renderFoundPopup('https://www.google.ru/chrome/browser/', 'Google Chrome');
            break;
          case 'Yandex Browser':
            this.renderFoundPopup('https://browser.yandex.ru/", "Яндекс Браузер');
            break;
          case 'Microsoft Edge':
            this.renderFoundPopup('https://www.microsoft.com/ru-ru/windows/microsoft-edge', 'Microsoft Edge');
            break;
          case 'Firefox':
            this.renderFoundPopup('https://www.mozilla.org/ru/firefox/new/', 'Mozilla Firefox');
            break;
          case 'Opera':
            this.renderFoundPopup('http://www.opera.com/ru/', 'Opera');
            break;
          case 'operamini':
            this.renderFoundPopup('http://www.opera.com/ru/mobile/mini', 'Opera Mini');
            break;
          case "operamobi":
            this.renderFoundPopup(' http://www.opera.com/ru/mobile', 'Opera Mobile');
            break;
          default:
            this.renderDefaultPopup();
            break;
        }
        this.popup = new als.Popup(this.$el);
        this.show();
      }
    },

    /**
     * Отобразить информацию для обновления текущего браузера пользователя
     * @param link - ссылка на новый браузер
     * @param name - название браузера
     */
    renderFoundPopup: function (link, name) {
      this.template = app.helpers.TemplateHelper.getTemplate('#old-browser-popup-found');
      this.$('.old-browser-content').html(this.template({
        browserName: name,
        browserLink: link
      }));
    },

    /**
     * Вывод стандартного сообщения о смене браузера, если не поддерживается.
     */
    renderDefaultPopup: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#old-browser-popup-default');
      this.$('.old-browser-content').html(this.template());
    },

    /**
     * Показать попап.
     */
    show: function () {
      this.popup.open();
    },

    /**
     * Скрыть попап.
     */
    close: function () {
      this.saveCookie();
      this.popup.close();
    },

    /**
     * Установка куки на скрытие отображения браузера на 30 дней
     */
    saveCookie: function () {
      app.helpers.CookieHelper.setCookie(
        'is_popup_old_browser_closed',
        1,
        {
          domain: '.' + app.helpers.UrlHelper.getDomain(),
          path: '/',
          expires: 30 * 24 * 3600
        }
      );
    }
  });

})();

}.call(window));